import _ from 'lodash';
import { combineReducers } from 'redux';

import {
  USERS_RECEIVE,
  USERS_REQUEST,
  USERS_REQUEST_FAILURE,
  USERS_REQUEST_SUCCESS,
} from '../action-types';

export function fetching(state = {}, action = {}) {
  const { type, payload = {} } = action;
  const { userIds } = payload;

  switch (type) {
    case USERS_REQUEST: {
      const values = _.zipObject(
        userIds,
        _.map(userIds, () => true)
      );
      return { ...state, ...values };
    }

    case USERS_REQUEST_SUCCESS:
    case USERS_REQUEST_FAILURE: {
      const values = _.zipObject(
        userIds,
        _.map(userIds, () => false)
      );
      return { ...state, ...values };
    }

    default:
      return state;
  }
}

export function items(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case USERS_RECEIVE: {
      const users = { ...state };
      payload.users.forEach((user) => {
        users[user.id] = user;
      });

      return users;
    }

    default:
      return state;
  }
}

export default combineReducers({
  items,
  fetching,
});
